const translations: Record<string, string> = {
  // Navbar
  "nav.home": "Acasă",
  "nav.about": "Despre Noi",
  "nav.services": "Servicii",
  "nav.news": "Noutăți",
  "nav.partner": "Deveniți Partener",
  "nav.cta": "Înregistrați-vă ca Solicitant",
  "nav.partnerAccess": "Acces Parteneri",

  // Hero
  "hero.label": "Centru Public de Consultanță — Republica Moldova",
  "hero.title1": "EU Next Grants",
  "hero.title2": "Consultanță & Suport de Proiecte",
  "hero.subtitle": "Ajutăm ONG-urile și organizațiile civice din Moldova să găsească, aplice și implementeze cu succes finanțări europene și internaționale — de la primul apel până la raportul final.",
  "hero.cta1": "Înregistrați-vă ca Solicitant",
  "hero.cta2": "Serviciile Noastre",
  "hero.scroll": "Derulați",

  // About Preview
  "aboutPreview.label": "Despre EU Next Grants",
  "aboutPreview.title": "Partenerul dedicat din Moldova pentru consultanță în granturi UE",
  "aboutPreview.p1": "EU Next Grants este un centru public de consultanță creat pentru a reduce decalajul dintre societatea civilă din Moldova și oportunitățile de finanțare europeană. Oferim suport complet — de la identificarea granturilor și evaluarea eligibilității până la redactarea aplicațiilor și supravegherea implementării proiectelor.",
  "aboutPreview.p2": "Echipa noastră include manageri de granturi certificați, specialiști în politici UE și profesioniști în managementul proiectelor cu peste un deceniu de experiență combinată în programe finanțate de UE în Europa de Est.",
  "aboutPreview.link": "Citiți povestea noastră",
  "aboutPreview.stat1.number": "",
  "aboutPreview.stat1.label": "ONG-uri Asistate",
  "aboutPreview.stat2.number": "",
  "aboutPreview.stat2.label": "Granturi Obținute",
  "aboutPreview.stat3.number": "",
  "aboutPreview.stat3.label": "Programe UE",

  // Services Preview
  "servicesPreview.label": "Ce Facem",
  "servicesPreview.title": "Suport complet pentru granturi, de la idee la implementare",
  "servicesPreview.viewAll": "Toate cele 7 servicii",
  "servicesPreview.explore": "Explorați toate serviciile",
  "servicesPreview.s01.title": "Identificarea & Cartografierea Granturilor",
  "servicesPreview.s01.desc": "Scanăm și cartografiem apelurile deschise de la UE și alți finanțatori majori, oferind un peisaj de finanțare personalizat pentru organizația dvs.",
  "servicesPreview.s02.title": "Evaluarea Eligibilității",
  "servicesPreview.s02.desc": "Înainte de a angaja resurse, evaluăm riguros eligibilitatea organizației dvs. față de criteriile de finanțare, reducând riscul de descalificare.",
  "servicesPreview.s03.title": "Redactarea & Revizuirea Propunerilor",
  "servicesPreview.s03.desc": "Experții noștri elaborează propuneri de granturi convingătoare și conforme. Oferim și revizuire independentă și asigurare a calității pentru propunerile redactate intern.",
  "servicesPreview.s04.title": "Proiectarea Bugetului & Planificarea Financiară",
  "servicesPreview.s04.desc": "Structurăm bugete de proiect realiste, pe deplin justificate și aliniate cu regulile de eligibilitate a costurilor ale finanțatorilor.",

  // Who We Work With
  "whoWeWork.label": "Cu Cine Lucrăm",
  "whoWeWork.title": "Sprijinim ecosistemul societății civile din Moldova",
  "whoWeWork.p": "Lucrăm cu o gamă largă de actori ai societății civile din Moldova — de la organizații comunitare de bază până la ONG-uri consacrate cu parteneriate internaționale. Indiferent dacă aplicați pentru primul grant sau extindeți un program finanțat de UE pe mai mulți ani, oferim suport personalizat la fiecare etapă.",
  "whoWeWork.cta": "Începeți o conversație",
  "whoWeWork.supportLabel": "Sprijinim",
  "whoWeWork.p1": "ONG-uri & asociații înregistrate",
  "whoWeWork.p2": "Autorități publice locale",
  "whoWeWork.p3": "Fundații comunitare",
  "whoWeWork.p4": "Instituții culturale & de patrimoniu",
  "whoWeWork.p5": "Organizații de tineret & civice",
  "whoWeWork.p6": "Instituții de cercetare & educaționale",

  // News Preview
  "newsPreview.label": "Ultimele de la EU Next Grants",
  "newsPreview.title": "Noutăți & Apeluri de Granturi",
  "newsPreview.viewAll": "Toate actualizările",
  "newsPreview.deadline": "Termen limită:",
  "newsPreview.seeAll": "Vedeți toate cele {{count}} actualizări",

  // Contact
  "contact.label": "Contactați-ne",
  "contact.title": "Începeți-vă călătoria spre granturi astăzi",
  "contact.p": "Contactați-ne pentru o consultație inițială gratuită. Specialiștii noștri vor analiza profilul organizației dvs. și vă vor consilia cu privire la cele mai potrivite oportunități de finanțare disponibile.",
  "contact.address": "Str. Maria Cebotari 37, Chișinău, Moldova",
  "contact.emailLabel": "info@eunextgrants.md",
  "contact.phone": "+373 22 000 000",
  "contact.hours": "Lun – Vin: 09:00 – 18:00",
  "contact.form.nameLabel": "Nume Complet *",
  "contact.form.emailLabel": "Adresă de Email *",
  "contact.form.orgLabel": "Organizație",
  "contact.form.messageLabel": "Mesaj *",
  "contact.form.messageNote": "(max 500 caractere)",
  "contact.form.namePlaceholder": "Numele dvs. complet",
  "contact.form.emailPlaceholder": "email@dvs.com",
  "contact.form.orgPlaceholder": "Numele ONG-ului sau instituției dvs.",
  "contact.form.messagePlaceholder": "Descrieți pe scurt organizația dvs. și tipul de suport de care aveți nevoie...",
  "contact.form.submit": "Trimiteți Mesajul",
  "contact.form.sending": "Se trimite...",
  "contact.form.error": "Ceva nu a mers bine. Vă rugăm să încercați din nou.",
  "contact.success.title": "Mesaj primit",
  "contact.success.p": "Vă mulțumim că ne-ați contactat. Un membru al echipei noastre vă va contacta în decursul unei zile lucrătoare.",
  "contact.success.again": "Trimiteți un alt mesaj",

  // About Page
  "about.hero.label": "Despre Noi",
  "about.hero.title": "Cine suntem și ce ne motivează",
  "about.mission.label": "Misiunea Noastră",
  "about.mission.title": "Democratizarea accesului la finanțare europeană",
  "about.mission.p1": "EU Next Grants a fost fondată pe o convingere simplă: fiecare ONG moldovenesc cu o misiune socială autentică merită acces egal la finanțare UE și internațională — indiferent de mărime, capacitate lingvistică sau experiență anterioară cu birocrația europeană.",
  "about.mission.p2": "Funcționăm ca un centru public de consultanță, nu ca o agenție comercială. Structurile noastre de tarife sunt concepute pentru a fi accesibile organizațiilor în stadiu incipient, iar noi oferim regulat servicii de consultanță pro-bono grupurilor comunitare din regiuni defavorizate.",
  "about.mission.p3": "Abordarea noastră este instituțională — riguroasă, temeinică și fundamentată pe cunoașterea profundă a ciclurilor de programare UE, cerințelor de conformitate și standardelor de evaluare a impactului.",
  "about.stats.s1": "ONG-uri Asistate",
  "about.stats.s2": "Granturi Facilitate",
  "about.stats.s3": "Programe Active",
  "about.history.label": "Istoria Noastră",
  "about.history.title": "Un deceniu de impact civic",
  "about.milestone.2014": "Fondată la Chișinău ca inițiativă civică de consultanță",
  "about.milestone.2016": "Primul portofoliu major de proiecte EU4Moldova — €1,2M obținuți",
  "about.milestone.2019": "Deveniți partener acreditat al Delegației Comisiei Europene în Moldova",
  "about.milestone.2021": "Extinderea serviciilor pentru acoperirea granturilor GIZ, USAID și Consiliul Europei",
  "about.milestone.2023": "Depășit pragul de €8M în granturi totale facilitate pentru societatea civilă din Moldova",
  "about.milestone.2025": "Lansarea Moldova NGO Grant Navigator — portal de resurse cu acces liber",
  "about.team.label": "Echipa Noastră",
  "about.team.title": "Specialiști seniori, experiență reală",
  "about.team.0.name": "Elena Moraru",
  "about.team.0.role": "Director Fondator & Consilier Senior de Granturi",
  "about.team.0.bio": "15 ani de experiență în managementul proiectelor finanțate de UE. Fost consilier al Ministerului Integrării Europene al Moldovei. Manager de proiecte UE certificat (IPMA Nivelul B).",
  "about.team.1.name": "Andrei Cojocaru",
  "about.team.1.role": "Șef al Departamentului de Dezvoltare a Propunerilor",
  "about.team.1.bio": "A condus peste 60 de aplicații de granturi de succes la Horizon Europe, Erasmus+ și cadrul EU4Moldova. Specialist în design de cadru logic și scriere narativă.",
  "about.team.2.name": "Natalia Rusu",
  "about.team.2.role": "Specialist în Conformitate Financiară",
  "about.team.2.bio": "Expertiză în regulile bugetare UE, eligibilitatea costurilor și pregătirea auditului. Formată de Curtea Europeană de Conturi și cadrul anti-fraudă OLAF.",
  "about.values.label": "Valorile Noastre",
  "about.values.title": "Principial. Transparent. Eficient.",
  "about.values.0.title": "Independență",
  "about.values.0.desc": "Funcționăm fără interese politice sau comerciale, asigurând că sfaturile noastre sunt întotdeauna în beneficiul dvs.",
  "about.values.1.title": "Transparență",
  "about.values.1.desc": "Prețuri clare, comunicare deschisă și divulgare completă a metodologiilor și limitărilor noastre.",
  "about.values.2.title": "Excelență",
  "about.values.2.desc": "Ne menținem la aceleași standarde ca ofițerii de program UE — riguroși, bazați pe dovezi și orientați spre rezultate.",
  "about.values.3.title": "Accesibilitate",
  "about.values.3.desc": "Suportul pentru granturi nu ar trebui să fie un privilegiu al instituțiilor mari. Lucrăm activ pentru a echilibra terenul de joc.",

  // Services Page
  "services.hero.label": "Serviciile Noastre",
  "services.hero.title": "Suport complet pentru granturi, de la primul apel până la raportul final",
  "services.core.label": "Servicii de Bază",
  "services.core.title": "Șapte domenii de suport specializat",
  "services.s01.title": "Identificarea Granturilor & Cartografierea Peisajului de Finanțare",
  "services.s01.desc": "Efectuăm o scanare amănunțită a tuturor apelurilor deschise relevante de la UE, Consiliul Europei și alți finanțatori majori activi în Moldova. Primiți o matrice de finanțare personalizată — potrivită pentru sectorul, dimensiunea și prioritățile dvs. strategice.",
  "services.s02.title": "Evaluarea Eligibilității & Analiza Pre-Aplicare",
  "services.s02.desc": "Înainte de angajarea oricăror resurse, efectuăm o verificare detaliată a eligibilității față de toate criteriile finanțatorului — statut juridic, focalizare tematică, scopul geografic, cerințele de co-finanțare și pragurile financiare — reducând riscul de respingere administrativă.",
  "services.s03.title": "Redactarea Propunerilor & Asistență Tehnică",
  "services.s03.desc": "Redactorii noștri seniori elaborează propuneri de granturi complete, convingătoare și pe deplin conforme — inclusiv narativul, cadrul logic, planul de lucru, matricea de risc și metodologia de evaluare. Oferim și evaluare independentă și asigurare a calității pentru propunerile elaborate de echipa dvs.",
  "services.s04.title": "Proiectarea Bugetului & Planificarea Financiară",
  "services.s04.desc": "Structurăm bugete de proiect realiste, echilibrate și pe deplin justificate conform regulilor de eligibilitate a costurilor finanțatorului. Aceasta include calculele costurilor de personal, tratamentul costurilor indirecte, evaluarea contribuțiilor în natură și alocarea bugetului partenerilor.",
  "services.s05.title": "Dezvoltarea Parteneriatelor & Construirea Consorțiilor",
  "services.s05.desc": "Multe granturi UE necesită consorții. Asistăm la identificarea și abordarea partenerilor potriviți — în Moldova și în străinătate — și ajutăm la negocierea acordurilor de parteneriat, definirea delimitării rolurilor și asigurarea clarității guvernanței în cadrul consorțiului.",
  "services.s06.title": "Suport pentru Implementarea Proiectului",
  "services.s06.desc": "Odată finanțat, oferim suport practic de implementare: cadre de monitorizare și evaluare, orientare în achizițiile publice, modele de raportare financiară, redactarea rapoartelor de progres și comunicarea cu Ofițerii de Program în numele dvs.",
  "services.s07.title": "Consolidarea Capacităților & Training în Granturi",
  "services.s07.desc": "Oferim programe de training personalizate pentru personalul ONG-urilor — acoperind arhitectura granturilor UE, abilitățile de scriere a propunerilor, managementul financiar conform regulilor UE și procedurile de achiziții PRAG. Disponibile ca ateliere de grup sau pachete de mentorat individual.",
  "services.lots.label": "Domenii Tematice",
  "services.lots.title": "Loturi tematice de granturi",
  "services.lots.p": "Activitatea noastră de consultanță este organizată în jurul a cinci loturi tematice aliniate cu domeniile prioritare de programare ale UE pentru Parteneriatul Estic și Moldova în special.",
  "services.lot1.lot": "Lotul 1",
  "services.lot1.title": "Democrație, Guvernanță & Statul de Drept",
  "services.lot1.desc": "Implicare civică, anti-corupție, reformă judiciară, integritate electorală și modernizarea administrației publice.",
  "services.lot2.lot": "Lotul 2",
  "services.lot2.title": "Drepturile Omului & Incluziunea Socială",
  "services.lot2.desc": "Egalitatea de gen, drepturile persoanelor cu dizabilități, suport pentru refugiați și migrație, incluziunea romilor și accesul la justiție.",
  "services.lot3.lot": "Lotul 3",
  "services.lot3.title": "Mediu, Climă & Tranziție Verde",
  "services.lot3.desc": "Protecția mediului, adaptarea la schimbările climatice, energie durabilă, gestionarea deșeurilor și biodiversitate.",
  "services.lot4.lot": "Lotul 4",
  "services.lot4.title": "Tineret, Educație & Patrimoniu Cultural",
  "services.lot4.desc": "Educație non-formală, leadership pentru tineret, parteneriate Erasmus+, dialog intercultural și conservarea patrimoniului.",
  "services.lot5.lot": "Lotul 5",
  "services.lot5.title": "Dezvoltare Locală & Reziliență Economică",
  "services.lot5.desc": "Dezvoltare rurală, suport pentru IMM-uri și cooperative, antreprenoriat social, diversificare economică locală.",
  "services.cta.label": "Gata să Aplicați?",
  "services.cta.title": "Găsim grantul potrivit pentru organizația dvs.",
  "services.cta.p": "Rezervați o consultație gratuită de 30 de minute cu unul dintre specialiștii noștri în granturi. Fără angajament.",
  "services.cta.btn": "Înregistrați-vă ca Solicitant",

  // News Page
  "news.hero.label": "Fiți Informat",
  "news.hero.title": "Noutăți & Anunțuri de Granturi",
  "news.hero.p": "Apeluri deschise, rezultate de proiecte, evenimente viitoare și actualizări de finanțare UE relevante pentru societatea civilă din Moldova.",
  "news.cat.all": "Toate",
  "news.cat.grant-call": "Apeluri Deschise",
  "news.cat.news": "Noutăți",
  "news.cat.event": "Evenimente",
  "news.cat.result": "Rezultate",
  "news.search": "Căutați știri...",
  "news.deadline": "Termen limită:",
  "news.readMore": "Citiți mai mult",
  "news.latest": "Cele mai recente",
  "news.moreUpdates": "Mai multe actualizări",
  "news.noResults.title": "Nu au fost găsite rezultate",
  "news.noResults.p": "Încercați să ajustați căutarea sau filtrul de categorie.",
  "news.sub.label": "Rămâneți la Curent",
  "news.sub.title": "Nu ratați niciun apel de grant deschis",
  "news.sub.p": "Trimitem un rezumat lunar concis al celor mai relevante oportunități de granturi UE și internaționale pentru ONG-urile din Moldova.",
  "news.sub.btn": "Solicitați Digest-ul de Granturi",

  // Register NGO Page
  "register.hero.label": "Rețea de Parteneri",
  "register.hero.title": "Înregistrați ONG-ul dvs. ca partener",
  "register.hero.p": "Alăturați-vă rețelei în creștere din Moldova a organizațiilor societății civile pregătite pentru granturi UE. Înregistrarea este gratuită și oferă ONG-ului dvs. acces prioritar la serviciile noastre de consultanță și informații de finanțare.",
  "register.why.label": "De ce să vă înregistrați?",
  "register.why.title": "Ce primesc ONG-urile partenere",
  "register.privacy": "Datele de înregistrare sunt folosite exclusiv în scopuri de coordonare a parteneriatului și nu sunt partajate cu terțe părți. Toate informațiile sunt tratate în conformitate cu cerințele GDPR ale UE.",
  "register.form.label": "Formular de Înregistrare",
  "register.benefit.0.title": "Acces la baza noastră de granturi",
  "register.benefit.0.desc": "Primiți digest-uri lunare curate de apeluri deschise potrivite pentru sectorul și capacitatea dvs.",
  "register.benefit.1.title": "Suport prioritar pentru propuneri",
  "register.benefit.1.desc": "ONG-urile partenere beneficiază de acces rapid la serviciile noastre de redactare și revizuire a propunerilor.",
  "register.benefit.2.title": "Cooptare în consorții",
  "register.benefit.2.desc": "Potrivim activ partenerii înregistrați cu oportunități de consorțiu UE în domeniul lor tematic.",
  "register.benefit.3.title": "Training & consolidarea capacităților",
  "register.benefit.3.desc": "Acces exclusiv la ateliere de grantare, webinarii și sesiuni individuale de mentorat.",

  // Registration Form
  "form.section.org": "Detalii Organizație",
  "form.section.projects": "Proiecte Implementate",
  "form.section.contact": "Persoană de Contact",
  "form.org.name.label": "Denumirea Legală Completă a Organizației *",
  "form.org.name.placeholder": "ex. Asociația pentru Dezvoltare Civică",
  "form.org.field.label": "Domeniu de Activitate *",
  "form.org.field.placeholder": "Selectați un domeniu...",
  "form.org.address.label": "Adresă Juridică *",
  "form.org.address.placeholder": "Stradă, Oraș, Raion",
  "form.org.phone.label": "Număr de Telefon *",
  "form.org.phone.placeholder": "+373 XX XXX XXX",
  "form.org.email.label": "Email Instituțional *",
  "form.org.email.placeholder": "contact@organizatia.md",
  "form.projects.note": "Enumerați 3 până la 5 proiecte pe care organizația dvs. le-a implementat. Includeți numele proiectului, finanțatorul și un scurt rezultat (max. 300 caractere fiecare).",
  "form.projects.label": "Proiect {{n}}",
  "form.projects.optional": "(opțional)",
  "form.projects.placeholder": "Denumirea proiectului / Anul realizării",
  "form.projects.add": "Adăugați un alt proiect ({{n}}/5)",
  "form.contact.name.label": "Nume Complet *",
  "form.contact.name.placeholder": "Prenume, Nume",
  "form.contact.role.label": "Funcție / Poziție *",
  "form.contact.role.placeholder": "ex. Director Executiv, Manager de Proiect",
  "form.submit": "Trimiteți Cererea de Parteneriat",
  "form.submitting": "Se trimite...",
  "form.error": "Ceva nu a mers bine. Vă rugăm să verificați datele și să încercați din nou.",
  "form.success.title": "Cerere Trimisă",
  "form.success.p": "Vă mulțumim pentru înregistrare. Echipa noastră va analiza profilul organizației dvs. și vă va contacta în termen de 3 zile lucrătoare.",
  "form.success.again": "Trimiteți o altă cerere",
  "form.activity.democracy": "Democrație & Guvernanță Civică",
  "form.activity.humanrights": "Drepturile Omului & Statul de Drept",
  "form.activity.environment": "Mediu & Tranziție Verde",
  "form.activity.youth": "Tineret, Educație & Învățare Non-Formală",
  "form.activity.social": "Incluziune Socială & Dezvoltare Comunitară",
  "form.activity.gender": "Egalitate de Gen & Emanciparea Femeilor",
  "form.activity.culture": "Cultură, Patrimoniu & Arte Creative",
  "form.activity.media": "Media, Jurnalism & Libertatea Presei",
  "form.activity.health": "Sănătate & Servicii Sociale",
  "form.activity.economic": "Dezvoltare Economică Locală",
  "form.activity.research": "Cercetare & Tehnologie Civică",
  "form.activity.other": "Altele",

  // Article Page
  "article.notFound.title": "Articolul nu a fost găsit",
  "article.notFound.p": "Articolul pe care îl căutați nu există sau a fost eliminat.",
  "article.notFound.back": "Înapoi la Noutăți",
  "article.back": "Înapoi la Noutăți",
  "article.deadline": "Termen limită:",
  "article.cta.title": "Aveți nevoie de ajutor cu această aplicație?",
  "article.cta.p": "Specialiștii noștri în granturi vă pot evalua eligibilitatea și sprijini propunerea pentru acest apel.",
  "article.cta.btn": "Obțineți o consultație gratuită",
  "article.sidebar.info": "Informații Cheie",
  "article.sidebar.deadline": "Termen limită",
  "article.sidebar.published": "Publicat",
  "article.sidebar.source": "Sursă",
  "article.sidebar.category": "Categorie",
  "article.related": "Articole similare",
  "article.allNews": "Toate noutățile & actualizările",
  "article.tags": "Etichete",

  // Footer
  "footer.tagline": "Ajutăm societatea civilă din Moldova să acceseze finanțări europene și internaționale.",
  "footer.rights": "Toate drepturile rezervate.",
};

export default translations;
